import cls from 'classnames';
import useLanguage from '../../useLanguage';

function ChangeLocaleBox() {
  let { changeLocale, activeLocale, pageLinks } = useLanguage();

  return (
    <li>
      <a
        className="change-locale-box"
        href={activeLocale === 'en' ? pageLinks.da : pageLinks.en}
        onClick={e => {
          e.preventDefault();
          changeLocale(activeLocale === 'en' ? window.__defaultLocale__ : 'en');
        }}
      >
        <span className="is-flex-mid">
          <span
            style={{ width: '1.65rem', height: '1.65rem' }}
            className={cls(
              'eb-flag',
              'font-blue',
              `eb-flag-${activeLocale === 'en' ? window.__defaultLocale__ : 'en'}`,
            )}
          />
          <span
            className="change-locale-box__label ml-1"
            style={{ fontSize: '0.85rem', textTransform: 'capitalize' }}
          >
            {activeLocale === 'en'
              ? window.__defaultLocaleData__.label
              : 'English'}
          </span>
        </span>
      </a>
    </li>
  );
}

export default ChangeLocaleBox;
